"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RichTextInput;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let Component = null;
var _ref = /*#__PURE__*/_react.default.createElement("div", null);
function RichTextInput(props) {
  const [isLoaded, setIsLoaded] = _react.default.useState(Component !== null);
  _react.default.useEffect(() => {
    if (isLoaded) return;
    Promise.resolve().then(() => _interopRequireWildcard(require("./rich-text-input-client-side"))).then(module => {
      Component = module.default;
      setIsLoaded(true);
    });
  }, [isLoaded]);
  if (!Component) {
    // We don't want to render the rich text editor on
    // the server side, because it relies on browser
    // APIs that aren't available in Node.js.
    return _ref;
  }
  return /*#__PURE__*/_react.default.createElement(Component, props);
}